import {Link} from "react-router-dom";
import {Breadcrumb, Image} from "antd";

import AboutUsImage1 from "../../assets/images/long_view3.jpg";
import AboutUsImage3 from "../../assets/images/factory1.jpg";
import AboutUsImage2 from "../../assets/images/long_view1.jpg";
import AboutUsImage4 from "../../assets/images/long_view2.jpg";
import HeaderImage from "../../assets/images/aboutUsHeader.jpg";

import "./AboutUsPage.css";

const AboutUs = () => {
    return (
        <div className="about-us-container">
            <div className="about-us-container-image">
                <img src={HeaderImage} alt="Header Background" />
            </div>

            <div className="about-us-header">
                <h1>О нас</h1>
                <Breadcrumb
                    items={[
                        {
                            title: <Link to="/">Главная страница</Link>
                        },
                        {
                            title: <span>О нас</span>,
                        },
                    ]}
                    className="about-us-breadcrumb"
                />
                <div className="under-breadcrumb-divider"></div>
            </div>

            <div className="about-us-content">
                <div className="about-us-text-column">
                    <div className="about-us-text-section">
                        <h2>Наша история</h2>
                        <p>
                            ООО <b> "АгроТрейд" </b> — надежный поставщик с собственным производством.
                            Наш путь начался в 2008 году с разведки месторождения и постановки его на баланс. В 2018 году
                            мы приступили к вскрытию карьера и строительству предприятия. А уже в 2021 году осуществили
                            первые поставки готовой продукции для наших клиентов.
                        </p>
                    </div>

                    <div className="about-us-text-section">
                        <h2>Наша миссия</h2>
                        <p>
                            Помочь производителям кормов работать эффективнее. Мы видим свою задачу в том, чтобы
                            обеспечить предприятия региона доступным и качественным сырьём, способствуя снижению
                            себестоимости кормов и укреплению местной промышленности.
                        </p>
                    </div>

                    <div className="about-us-text-section">
                        <h2>Наше производство</h2>
                        <p>
                            Наше предприятие оснащено современным оборудованием от ведущих российских и
                            зарубежных производителей. Мы используем передовые технологии добычи и переработки
                            мела, что позволяет нам сохранять все природные качества сырья.
                        </p>
                        <p>
                            Производственный процесс включает в себя:
                        </p>
                        <ul className="about-us-list">
                            <li>Добычу мела открытым способом</li>
                            <li>Предварительную очистку и сортировку</li>
                            <li>Помол и сушку</li>
                            <li>Контроль качества на каждом этапе</li>
                            <li>Упаковку и отгрузку продукции</li>
                        </ul>
                    </div>

                    <div className="about-us-text-section">
                        <h2>Контроль качества</h2>
                        <p>
                            Мы уделяем особое внимание контролю качества на всех этапах производства.
                            Наша собственная лаборатория, оснащенная современным оборудованием, позволяет
                            нам проводить все необходимые анализы и гарантировать стабильное качество
                            продукции.
                        </p>
                    </div>

                    <div className="about-us-text-section">
                        <h2>Наши ценности</h2>
                        <div className="about-us-values">
                            <div className="about-us-value-item">
                                <h3>Качество</h3>
                                <p>Мы гарантируем высочайшее качество нашей продукции</p>
                            </div>
                            <div className="about-us-value-item">
                                <h3>Надежность</h3>
                                <p>Стабильные поставки и соблюдение сроков</p>
                            </div>
                            <div className="about-us-value-item">
                                <h3>Экологичность</h3>
                                <p>Мы заботимся об окружающей среде</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="about-us-images-column">
                    <div className="about-us-image-container">
                        <Image
                            src={AboutUsImage1}
                            alt="Добыча мела"
                            className="about-us-image"
                            preview={false}
                        />
                    </div>

                    <div className="about-us-image-container">
                        <Image
                            src={AboutUsImage4}
                            alt="Добыча мела"
                            className="about-us-image"
                            preview={false}
                        />
                    </div>

                    <div className="about-us-image-container">
                        <Image
                            src={AboutUsImage3}
                            alt="Добыча мела"
                            className="about-us-image"
                            preview={false}
                        />
                    </div>

                    <div className="about-us-image-container">
                        <Image
                            src={AboutUsImage2}
                            alt="Добыча мела"
                            className="about-us-image"
                            preview={false}
                        />
                    </div>
                </div>
            </div>

            <div className="about-us-statistics">
                <h2>Мы в цифрах</h2>
                <div className="about-us-statistics-row">
                    <div className="about-us-statistic">
                        <h3>8+</h3>
                        <p>Лет успешной работы</p>
                    </div>
                    <div className="about-us-statistic">
                        <h3>50 000+</h3>
                        <p>Тонн добытого мела</p>
                    </div>
                    <div className="about-us-statistic">
                        <h3>100+</h3>
                        <p>Довольных клиентов</p>
                    </div>
                    <div className="about-us-statistic">
                        <h3>95%</h3>
                        <p>Содержание кальция</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutUs;